<template>
  <v-card>
    <v-card-title>
      <v-btn
        v-if="step.number"
        class="ma-2"
        outlined
        rounded
        disabled
        color="primary"
        style="color: #3f68b1 !important"
        >Шаг {{ step.number }}
      </v-btn>
    </v-card-title>
    <v-card-text>
      <input type="number" name="number" :value="step.number" hidden />
      <v-col lg16>
        <div class="subtitle-1">Описание</div>
        <ckeditor
          :editor="ckeditor"
          v-model="step.description"
          :config="ckConfig"
          type="classic"
          :upload-adapter="UploadAdapter"
          @ready="setUploader"
        >
        </ckeditor>
        <input type="text" name="description" :value="step.description" hidden />
      </v-col>
      <v-col cols="3">
        <v-menu
          ref="dateMenu"
          v-model="deadlineMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="step.deadline"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="step.deadline"
              name="deadline"
              prepend-icon="event"
              clearable
              readonly
              v-on="on"
              outlined
            >
              <template v-slot:label>
                <span>Срок выполнения <span v-if="dateLabel">до: </span> {{ dateLabel }}</span>
              </template>
            </v-text-field>
          </template>
          <v-date-picker v-model="step.deadline" locale="ru-ru" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="deadlineMenu = false">Закрыть</v-btn>
            <v-btn text color="primary" @click="$refs.dateMenu.save(step.deadline)">
              Выбрать
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-card-text>
    <v-card-actions>
      <!--      <v-layout row wrap>-->
      <v-flex lg6
        ><v-btn v-if="step.id" outlined @click="updateStep" color="green"
          >Обновить Шаг {{ step.number }}</v-btn
        ></v-flex
      >
      <v-spacer></v-spacer>
      <v-flex lg6 class="text-right"
        ><v-btn outlined @click="deleteStep" color="error"
          >Удалить Шаг {{ step.number }}</v-btn
        ></v-flex
      >
      <!--      </v-layout>-->
    </v-card-actions>
  </v-card>
</template>

<script>
import { isEmpty } from 'lodash'
import {
  defaultTaskStep,
  getDeleteTaskStepResponse,
  getUpdateTaskStepResponse,
  ITaskStep,
} from '@/api/activist/task'
import ckeditorMixin from '@/mixins/ckeditor'
import forms from '@/mixins/forms'

export default {
  name: 'TaskStep',
  mixins: [ckeditorMixin, forms],
  props: {
    step: {
      type: ITaskStep,
      default: () => {
        return { ...defaultTaskStep }
      },
    },
  },
  data() {
    return {
      deadlineMenu: false,
      _step: {
        description: '',
        deadline: null,
        number: 0,
        kind: '',
      },
    }
  },
  computed: {
    dateLabel() {
      if (isEmpty(this.step.deadline)) {
        return ''
      }
      const date = this.$moment(this.step.deadline)
      return date.isValid() ? date.format('LL') : ''
    },
  },
  methods: {
    updateStep() {
      const step = { ...this.step }
      if (step.deadline) {
        step.deadline = this.$moment(step.deadline).format('YYYY-MM-DDTHH:mm:ssZ')
      }
      getUpdateTaskStepResponse(this.axios, this.step.task_id, this.step.id, step)
        .then((resp) => {
          const step = resp.data
          if (step.deadline) {
            step.deadline = this.$moment(step.deadline).format('YYYY-MM-DD')
          }
          this.$emit('step-was-updated', step)
          this.showSnackbar(this.messages.successUpdated, 'success')
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
    deleteStep() {
      if (!this.step.id) {
        this.$emit('step-was-deleted', this.step.number)
        return
      }
      getDeleteTaskStepResponse(this.axios, this.step.task_id, this.step.id)
        .then((resp) => {
          this.$emit('step-was-deleted', this.step.number)
          this.showSnackbar(this.messages.successDeleted, 'success')
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
  },
}
</script>
